import { IBookmark } from "./IBookmark";

export interface IBookmarkSpecifiable {
  bookmark: IBookmark;
}

export function instanceOfIBookmarkSpecifiable(instance: any): instance is IBookmarkSpecifiable {
  return instance
    && (instance.bookmark !== undefined);
}
